// DSS Documentation on Angular - http://tiny.sc/cgangular
// DSS Documentation on Angular Reuse - http://tiny.sc/cgangularreuse
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { SocoPleaseWaitComponent } from '@app/soco/http/soco-please-wait.component';
// DSS Documentation on SocoHttpService - http://tiny.sc/cgsocohttpservice
import { SocoHttpService } from '@app/soco/http/soco-http.service';
// DSS Documentation on SocoWebAuthService - http://tiny.sc/socowebauthservice
import { SocoWebAuthService } from '@app/soco/http/soco-web-auth.service';

const SOCO_MODULE_DIRECTIVES = [
    SocoPleaseWaitComponent
];

@NgModule({
    imports: [
        // BrowserModule,
        CommonModule,
        HttpClientModule
    ],
    exports: SOCO_MODULE_DIRECTIVES,
    declarations: SOCO_MODULE_DIRECTIVES,
    providers: [
        // DSS Documentation on SocoHttpService - http://tiny.sc/cgsocohttpservice
        SocoHttpService,
        // DSS Documentation on SocoWebAuthService - http://tiny.sc/socowebauthservice
        SocoWebAuthService
    ]
})
export class SocoHttpModule { }
